const login = {
  "login.title": "Sign In",
  "login.subtitle": "Enter your phone number to receive an OTP",
  "login.phoneLabel": "Phone Number",
  "login.phonePlaceholder": "1234567890",
  "login.phoneHint": "Enter your number without the leading zero — country code is already set",
  "login.sendOtp": "Send OTP",
  "login.sendingOtp": "Sending OTP...",
  "login.error.phoneRequired": "Please enter your phone number",
  "login.error.phoneIncomplete": "Phone number is incomplete — check the correct number of digits",
  "login.error.sendFailed": "Failed to send OTP",
  "login.backToHome": "Back to Home",
};

export default login;